export const StyleVars = {
    pricingCardWidth: '286px',
    pricingCardHeight: '363px',
    pricingCardMobileWidth: '327px',
    pricingCardMobileHeight: '360px',
    pricingCardsWidth: 'calc(286px + 286px + 32px)',
    pricingCardsHeight: '363px',
    pricingCardsMobileHeight: 'calc(363px + 363px + 16px)'
};
